<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange" :rowSelection="rowSelection">
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="selected(rowKey.data)">选择</a>
        </span>
      </template>
    </standard-table>
  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import config from "@/config";
import { setTimeout } from "timers";

let announcementTypeOptions = [];
export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom
  },
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "title",
          name: "标题"
        },
        {
          type: "select",
          key: "announcementType",
          name: "类型",
          options: announcementTypeOptions
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 70,
          scopedSlots: { customRender: "action" },
          fixed: "left"
        },
        {
          title: "标题",
          dataIndex: "title",
          sorter: true
        },
        {
          title: "通知类型",
          width: 150,
          dataIndex: "announcementTypeStr"
        },
        {
          title: "是否置顶",
          width: 150,
          dataIndex: "isSticky",
          customRender: (text, row, index) => {
            return row.isSticky == true ? "是" : "否";
          }
        },
        {
          title: "置顶期",
          width: 200,
          dataIndex: "stickyBeginTime",
          customRender: (text, row, index) => {
            return row.isSticky == true
              ? this.formatDate(row.stickyBeginTime, "YYYY-MM-DD") +
                  " ~ " +
                  this.formatDate(row.stickyEndTime, "YYYY-MM-DD")
              : "";
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { title: "", announcementType: "" },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      rowSelection: null,
      title: ""
    };
  },
  async mounted() {
    this.GetAnnouncementTypeOptions();
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.ProductName = p.values.ProductName;
      this.filterdata.ProductCode = p.values.ProductCode;
      this.filterdata.isActive = true;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log(selectedRows);
      this.selectedRows = selectedRows;
      this.rowSelection = {
        selectedRows: selectedRows,
        onChange: this.onSelectChange
      };
    },
    selected(record) {
      this.$emit("getSelectedAnnouncement", record);
    },
    async GetAnnouncementTypeOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 2 });
      if (dictionary) {
        announcementTypeOptions = [];
        dictionary.forEach(a => {
          announcementTypeOptions.push({
            name: a.text,
            val: a.value
          });
        });
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      options.status = 2;
      let data = await api.GetAnnouncementList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Information/Announcement/SelectList.vue